// import React from "react"
// import Typewriter from "typewriter-effect"
// import { navigate } from "gatsby-link"
// import "../styles/contact.scss"
// import Sending from "./Sending"
// import emailjs from 'emailjs-com';

// export default function Contact({ close }) {
//   const [state, setState] = React.useState({})
//   const [messageSending, setMessageSending] = React.useState(false)

//   const handleChange = e => {
//     setState({ ...state, [e.target.name]: e.target.value })
//   }

//   const handleSubmit = e => {


//     e.preventDefault()
//       emailjs.send('service_cj7vl9v', 'template_hil9c96', state, '6t1QhvlcIZ9tNrJky')
//         .then((response) => {
//           console.log('Email sent:', response);
//         })
//         .catch((error) => {
//           console.error('Error sending email:', error);
//         });
    
//     // setMessageSending(true)
//     // const url = `/.netlify/functions/contact`
//     // fetch(url, {
//     //   method: "POST",
//     //   body: JSON.stringify(state),
//     // })
//     //   .then(response => {
//     //     response.ok
//     //       ? navigate("/success")
//     //       : alert("An error occured while trying to send contact message!")
//     //     setMessageSending(false)
//     //   })
//     //   .then(close)
//   }

//   return (
//     <div className="contactContainer">
//       <div style={{ margin: "auto", minWidth: "100%" }}>
//         <h1 className="contactH1">
//           <Typewriter
//             onInit={typewriter => {
//               typewriter
//                 .typeString("Contact me")
//                 .start()
//                 .callFunction(function (state) {
//                   state.elements.cursor.style.display = "none"
//                 })
//             }}
//           />
//         </h1>
//         <form
//           name="contact"
//           method="post"
//           // action="/contact-us"
//           onSubmit={handleSubmit}
//         >
//           <p hidden>
//             <label>
//               Don’t fill this out:{" "}
//               <input name="bot-field" onChange={handleChange} />
//             </label>
//           </p>
//           <input type="hidden" name="form-name" value="contact"></input>
//           <label htmlFor="name">Your Name</label>
//           <input
//             type="text"
//             id="name"
//             name="name"
//             required={true}
//             placeholder="Name"
//             onChange={handleChange}
//           />
//           <label htmlFor="email">Your Email</label>
//           <input
//             type="email"
//             id="email"
//             name="email"
//             required={true}
//             placeholder="E-Mail address"
//             onChange={handleChange}
//           />
//           <label htmlFor="message">Message</label>
//           <textarea
//             id="message"
//             name="message"
//             required={true}
//             placeholder="Hi Utsav, we’re looking for a backend engineer with Python / Go experience to work on …"
//             rows="3"
//             onChange={handleChange}
//           ></textarea>
//           {messageSending ? (
//             <button type="submit" disabled={messageSending}>
//               {/* <Sending /> */}
//             </button>
//           ) : (
//             <button type="submit" disabled={messageSending}>
//               Send
//             </button>
//           )}
//         </form>
//       </div>
//     </div>
//   )
// }


import React from "react"
import { navigate } from "gatsby-link"
import "../styles/contact.scss"

export default function Contact({ close }) {
  const [state, setState] = React.useState({})
  const [messageSending, setMessageSending] = React.useState(false)

  const handleChange = e => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setMessageSending(true)

    try {
      const response = await fetch("/.netlify/functions/contact", {
        method: "POST",
        body: JSON.stringify(state),
      })

      if (!response.ok) {
        throw new Error("Failed to send message")
      }

      setMessageSending(false)
      navigate("/success")
      close && close()
    } catch (error) {
      console.error(error)
      setMessageSending(false)
      alert("Something went wrong while sending your message.")
    }
  }

  return (
    <div className="contactContainer">
      <div style={{ margin: "auto", minWidth: "100%" }}>
        <h1 className="contactH1">Contact</h1>

        <p className="contactNote">
          Serious inquiries only. I typically respond within 1–2 days.
        </p>

        <form name="contact" method="post" onSubmit={handleSubmit}>
          {/* Honeypot */}
          <p hidden>
            <label>
              Don’t fill this out:
              <input name="bot-field" onChange={handleChange} />
            </label>
          </p>

          <input type="hidden" name="form-name" value="contact" />

          <label htmlFor="name">Your Name</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            placeholder="Your name"
            onChange={handleChange}
          />

          <label htmlFor="email">Your Email</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            placeholder="your@email.com"
            onChange={handleChange}
          />

          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            required
            rows="5"
            placeholder="Hi Utsav, we’re looking for a backend engineer with Python / Go experience to work on …"
            onChange={handleChange}
          />

          <button type="submit" disabled={messageSending}>
            {messageSending ? "Sending…" : "Send"}
          </button>
        </form>
      </div>
    </div>
  )
}